const AddressComp = addressComponents => {
  let houseNumber = '';
  let street = '';
  let city = '';
  let zipCode = '';
  let subpremise = '';
  let country = '';

  addressComponents.forEach(el => {
    if (el.types.includes('street_number')) {
      houseNumber = el.long_name;
    } else if (el.types.includes('route')) {
      street = el.long_name;
    } else if (el.types.includes('locality')) {
      city = el.long_name;
    } else if (el.types.includes('postal_code')) {
      zipCode = el.long_name;
    } else if (el.types.includes('subpremise')) {
      subpremise = el.long_name;
    } else if (el.types.includes('country')) {
      country = el.long_name;
    }
  });

  if (subpremise) {
    houseNumber = `${subpremise}/${houseNumber}`;
  }

  return {
    houseNumber,
    street,
    city,
    zipCode,
    subpremise,
    country,
  };
};

export default AddressComp;
